import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationConstant } from '@constant/navigation.constant';
import { RequestHelper } from '@helper/request.helper';
import { MessageConstant } from '@constant/message.constant';
import { environment } from '@environments/environment';
import { APIConstant } from '@constant/api.constant';
import { DokuVaStorage } from '@storage/doku-va.storage';

@Component({
  selector: 'app-payment-doku-va',
  templateUrl: './payment-doku-va.component.html',
  styleUrls: ['./payment-doku-va.component.css']
})
export class PaymentDokuVaComponent implements OnInit {

  isLoading: boolean;
  isSuccess: boolean;
  vaNumber: number;
  customerName: string;
  amount: string;

  constructor(
    private router: Router,
    private storage: DokuVaStorage,
    private apiService: RequestHelper
  ) {
    this.isSuccess = true;
    this.isLoading = false;
  }

  ngOnInit(): void {
    if (this.storage.data == null) {
      this.router.navigate([NavigationConstant.DOKUVA_INQUIRY]);
    } else {
      this.vaNumber = this.storage.data.vaNumber;
      this.customerName = this.storage.data.customerName;
      this.amount = this.storage.data.amount;
    }
  }

  submitPayment() {
    this.storage.data.amount = this.amount;
    if (this.amount.toString().length > 10) {
      this.openDialog(MessageConstant.NOT_FOUND);
    } else {

      let payload = {
        'transactionno': this.storage.data.transactionNo,
        'currency': this.storage.data.currency,
        'amount': this.amount,
        'vanumber': this.storage.data.vaNumber
      };
      this.isLoading = true;
      // this.router.navigate([NavigationConstant.BRISYARIAH_PAYMENT_RESULT]); //for moc, activate
      this.apiService.post(environment.apiUrl + APIConstant.DOKUVA_PAYMENT, JSON.stringify(payload)).subscribe((data) => {
        this.storage.payment = data;
        this.router.navigate([NavigationConstant.DOKUVA_PAYMENT_RESULT])
      }, (err) => this.isLoading = false);
      this.isLoading = false;
    }
  }

  openDialog(result) {
    this.apiService.openDialog(result, NavigationConstant.DOKUVA_INQUIRY);
  }
}
